import * as Types from './actions.types';

function createInitialState() {
  return {
    user: null,
    isFetching: false,
    notFound: false
  };
}

export default function publicProfile(state = createInitialState(), action) {
  switch (action.type) {
    case Types.PUBLIC_PROFILE_INIT:
      return createInitialState();
    case Types.PUBLIC_PROFILE_GET:
      return {
        ...state,
        isFetching: true
      };
    case Types.PUBLIC_PROFILE_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        notFound: false,
        user: action.user
      };
    case Types.PUBLIC_PROFILE_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        notFound: true
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/publicUser/redux/reducers.js